import { registerLocaleData, DatePipe, IMAGE_CONFIG } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEnUs from '@angular/common/locales/en';
import localeEnGb from '@angular/common/locales/en-GB'; // For en-UK
import localeHr from '@angular/common/locales/hr';
import {
  LOCALE_ID,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { LayoutModule } from '@generic/layout/layout.module';
import { AppInitService } from '@services/app-init.service';
import { TranslationService } from '@services/translation.service';
import { AddClientDialogComponent } from '@shared/components/add-client-dialog/add-client-dialog.component';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { EN_GB } from '@shared/consts/common.consts';
import { TranslationPipe } from '@shared/pipes/translation.pipe';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localeEnUs, 'en-US');

export function localeFactory() {
  return TranslationService.supportedLanguages.includes(navigator.language)
    ? navigator.language
    : EN_GB;
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    LayoutModule,
    MatSidenavModule,
    TranslationPipe,
    ConfirmDialogComponent,
    AddClientDialogComponent,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  providers: [
    provideAnimations(),
    provideToastr(),
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'expandable-overlay-panel' },
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true },
    },
    {
      provide: LOCALE_ID,
      useFactory: localeFactory,
    },
    provideAppInitializer(() => {
      const initializerFn = (
        (service: AppInitService) => () =>
          service.init()
      )(inject(AppInitService));
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
